import { ApplicationManager } from "@westpierstudio/luma/application";
import { AudioManager } from "@westpierstudio/luma/audio";
import { PixiFactory } from "@westpierstudio/luma/factory";
import { DefaultLayout } from "@westpierstudio/luma/layout";
import { ResourcesManager } from "@westpierstudio/luma/resources";
import { IOryxServiceProvider } from "@westpierstudio/core-module-oryx/game";
import { Comms, CurrencyService, DebugService, Gamebridge, RGSData, UILayout, UIMessages } from "@westpierstudio/core-module-oryx/services";
import { ILocalStorage } from "@westpierstudio/core-module-oryx/services/localstorage";
import { Analytics } from "@westpierstudio/core-module-oryx/services/analytics";
import { DragonsVsPandasLoading } from "./DragonsVsPandasLoading";
import { DragonsVsPandsPaytableContentFactoryService } from "./paytable/DragonVsPandasPaytableContentFactoryService";
import { PlayerInactivityService } from "@westpierstudio/core-module-oryx/services/playerinactivity";

export class GameServices implements IOryxServiceProvider {

    constructor(
        public layout: DefaultLayout,
        public resources: ResourcesManager,
        public application: ApplicationManager,
        public factory: PixiFactory,
        public loader: DragonsVsPandasLoading,
        public audio: AudioManager,
        public rgsData: RGSData,
        public comms: Comms,
        public adminComms: Comms,
        public gameBridge: Gamebridge,
        public uiLayout: UILayout,
        public localStorage: ILocalStorage,
        public currency: CurrencyService,
        public loadscreenLayout: DefaultLayout,
        public splashscreenLayout: DefaultLayout,
        public analytics: Analytics,
        public UIMessages: UIMessages,
        public debug: DebugService,
        public playerInactivity: PlayerInactivityService,
        public paytableContentFactory: DragonsVsPandsPaytableContentFactoryService
    ) {
    }
}